/* eslint-disable no-param-reassign */
import {createSlice, PayloadAction} from '@reduxjs/toolkit'
// import {http} from 'hiya-common/src/utils/axios'

const initialState: {
  update?: boolean
} = {
  update: false,
}

export const TurnPlateSlice = createSlice({
  name: 'TurnPlate',
  initialState,
  reducers: {
    changeUpdate: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        update: action.payload,
      })
    },
  },
  extraReducers: (builder) => {},
})

export default TurnPlateSlice.reducer
export const TurnPlateActions = TurnPlateSlice.actions
